import React from "react";

const WhitelabelContext = React.createContext({});

export default WhitelabelContext;
